const translations = {
    chooseEntity: 'Choose {{entityType}}',
    chooseOne: 'Choose one'
};

export default translations;
